import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface DataDialogProps {
  open: boolean;
  onClose: () => void;
  data: Record<string, unknown>;
}

export function DataDialog({ open, onClose, data }: DataDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Formulardaten</DialogTitle>
      <DialogContent>
        <pre
          style={{
            overflow: "auto",
            fontSize: "0.875rem",
            fontFamily: "monospace",
            margin: 0,
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}
